  import React, { useState, useEffect, FC, forwardRef } from "react";
import {
  getAllResources,
  getUserPreferences,
} from "../../../../action/cultureAction";

//MUI
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import EventIcon from "@mui/icons-material/Event";
import EventMarkerType from "./EventMarkerType";
import { EventMarkerItem, EventMarkerSave } from "./EventMarker.d";
import { useDropzone } from "react-dropzone";
import Moment from "moment";
import APIutil from "../../../../api/APIutils";
import * as url from "../../../../api/url";
import ActionButtons from "./ActionButtons";
import {
  formatBytes,
  setBldingIds,
  DropFileText,
  BrowseFileText,
  useStyles,
} from "./eventMarker.util";
import DragandDropFileList from "./file-upload/DragandDropFileList";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import { getAllBuildingsList } from "../../../../action/ReportManagement/ManageReports";
import Conversions from "../../../../Resources/Conversions";
import moment from "moment";
import "Assets/Reports/EventMarkers.css";
import { setAmplitudeEvent } from "../../../../amplitude/amplitude";

export interface CreateEventMarkerProp {
  backToList: Function;
  selectedEventMarker: EventMarkerItem;
  buildingOptions: Array<string>;
  eventMarkerData: Array<EventMarkerItem>;
}

export interface BuildingFormat {
  value: string;
  label: string;
}

export interface BuildingList {
  siteID: number;
  siteName: string;
  tracerSummitSiteName: string;
}

export interface FileBlob {
  Name: string;
  Data: any;
}

export interface FileUpload {
  Key: any;
  Val: string;
}

export interface Attachment {
  id: number;
  name: string;
  size: string;
  lastModifiedDate: string;
  type: string;
}

const buildingsList = (state: any) => state.DataExportBuildingReducer.Buildings;
const userPreferences = (state: any) =>
  state.userPreferencesRootReducer.UserPreference;

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const CreateEventMarker: FC<CreateEventMarkerProp> = (props) => {
  const dispatch = useDispatch();
  const labels = useSelector(
    (state: any) =>
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference
  );
  const { backToList, selectedEventMarker, buildingOptions, eventMarkerData } =
    props;

  const buildingsSelector =
    (useSelector(buildingsList) as Array<BuildingList>) || null;
  const preferencesData = useSelector(userPreferences);

  const classes = useStyles();

  const [markerTypeId, setMarkerTypeId] = useState(-1);
  const [markerTypeName, setMarkerTypeName] = useState("");
  const [markerTypeLabel, setMarkerTypeLabel] = useState("");
  const [markerColor, setMarkerColor] = useState("");
  const [bldList, setBldList] = useState<Array<string>>([]);
  const [dateValue, setDateValue] = useState<any>(new Date());
  const [buildings, setBuildings] = useState<Array<BuildingFormat>>([]);
  const [buildingVals, setbuildingVals] =
    useState<Array<string>>(buildingOptions);
  const [markerId, setMarkerId] = useState(0);
  const [displayedOptions, setdisplayedOptions] =
    useState<Array<string>>(buildingOptions);
  const [localeValue, setLocaleValue] = useState("" as string);
  const [markerDescription, setMarkerDescription] = useState("");
  const [attachments, setAttachments] = useState<Array<Attachment>>([]);
  const [uploadBlob, setuploadBlob] = useState<Array<FileBlob>>([]);
  const [upload, setupload] = useState<Array<FileUpload>>([]);
  const [markerTypeUsage, setMarkerTypeUsage] = useState(0);
  const [showTypeEdit, setShowTypeEdit] = useState<boolean>(false);
  const [fileError, setfileError] = useState<Array<boolean>>([]);
  const [checkForSave, setCheckForSave] = useState<boolean>(false);
  const [typeErrors, setTypeErrors] = useState<Array<boolean>>([
    false,
    false,
    false,
    false,
  ]);
  const [dateError, setDateError] = useState<boolean>(false);
  const [selected, setSelected] = useState<Array<string>>([]);
  const [isSelectedError, setisSelectedError] = useState(false);
  const [searchText, setSearchText] = useState("" as string);

  const [userFormat, setUserFormat] = useState("" as string);
  const [duplicate, setDuplicate] = useState(false as boolean);
  const isAllSelected =
    buildings.length > 0 && selected.length === buildings.length;

  const { getRootProps, getInputProps, open, acceptedFiles, fileRejections } =
    useDropzone({
      // Disable click and keydown behavior
      noClick: true,
      noKeyboard: true,
      accept: {
        "image/jpeg": [".jpeg", ".jpg"],
        "image/png": [".png"],
        "image/gif": [".gif"],
        "text/csv": [".csv", ".xlsx", ".xls"],
        "application/pdf": [".pdf"],
        "application/msword": [".doc"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          [".docx"],
        "text/plain": [".txt"],
      },
      maxFiles: 10,
      multiple: true,
    });

  let isRequiredText: string = labels["IsRequired.Text"];

  useEffect(() => {
    const isUploadedFiles = acceptedFiles.length > 0;
    const docs: Array<any> =
      acceptedFiles.length > 0 ? acceptedFiles : attachments;
    const upBlob: Array<any> = uploadBlob;
    const fileUpload: Array<any> = upload;

    if (docs && docs[0] && docs.length > 0) {
      console.log(docs);
      if (typeof docs[0].lastModifiedDate !== "string") {
        let newDocsFormat: Array<Attachment> = [];
        docs.forEach((file) => {
          newDocsFormat.push({
            id: 0,
            name: file.name,
            size: formatBytes(file.size),
            lastModifiedDate: Moment().format("MMM DD YYYY"),
            type: file.type,
          });
          // add new file to the previously added, this way we don't override the current value in the array
          setAttachments((attachments) => [
            ...attachments,
            {
              id: 0,
              name: file.name,
              size: formatBytes(file.size),
              lastModifiedDate: Moment().format("MMM DD YYYY"),
              type: file.type,
            },
          ]);

          setfileError((fileError) => [...fileError, false]);
        });
      } else {
        setAttachments(docs);
      }
      docs.forEach(async (file) => {
        if (isUploadedFiles) {
          let blobEntries = upBlob.filter((b) => b.Name === file.name);
          if (blobEntries.length === 0) {
            upBlob.push({
              Name: file.name,
              Data: await getBlobStringFromURL(URL.createObjectURL(file)),
            });
            setuploadBlob(upBlob);
          }
        }

        let exists = fileUpload.filter((f) => f.Val === file.name);
        if (exists.length === 0) {
          fileUpload.push({
            Val: file.name,
            Key: isUploadedFiles ? 0 : file.id,
          });
          setupload(fileUpload);
        }
      });
    }
  }, [acceptedFiles]);

  useEffect(() => {
    const rejected = fileRejections;
    if (rejected.length > 0) {
      setfileError((fileError) => [...fileError, true]);
    }
  }, [fileRejections]);

  const removeFile = (id: number) => {
    let selAttach: Attachment = attachments[id];
    let docId: number = -1;
    let docName: string = "";

    if (selAttach && selAttach !== null) {
      docId = selAttach.id;
      docName = selAttach.name;
    }

    setAttachments((currentFile) => currentFile.filter((file, i) => i !== id));
    setupload((currentUpload) => currentUpload.filter((upload, i) => i !== id));
    setfileError((fileError) => fileError.filter((error, i) => i !== id));

    // if this is a new uploaded file, need to remove it from the blob and accepted files collection
    if (docId === 0 && docName !== "") {
      let blobIdx: number = uploadBlob.findIndex((ub) => ub.Name === docName);

      if (blobIdx >= 0) setuploadBlob([...uploadBlob.splice(blobIdx, 1)]);

      let fIdx: number = acceptedFiles.findIndex((ac) => ac.name === docName);

      if (fIdx >= 0) acceptedFiles.splice(fIdx, 1);
    }
  };

  const removeErrorFile = () => {
    setfileError((fileError) => fileError.filter((error, i) => error !== true));
  };

  // whats the else statement for
  async function saveAttachments(): Promise<void> {
    setCheckForSave(true);
    if (uploadBlob && uploadBlob.length > 0) {
      APIutil.postData(url.put_Attachments, uploadBlob)
        .then(() => {
          saveMarker();
        })
        .catch((error) => {
          throw error;
        });
    } else {
      saveMarker();
    }
  }

  async function getBlobStringFromURL(fBlob) {
    let b = await fetch(fBlob).then((r) => r.blob());
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(b);
    });
  }

  async function saveMarker(): Promise<void> {
    if (dateValue === null || dateValue === "") {
      setDateError(true);
    }

    if (selected === null || selected.length === 0) {
      setisSelectedError(true);
    }

    if (validInputs()) {
      const siteIds: Array<number> = setBldingIds(bldList, buildingsSelector);

      const data: EventMarkerSave = {
        EventMarkerId: markerId,
        EventMarkerDescription: markerDescription,
        EventMarkerDate: Moment(dateValue).format("MM/DD/YYYY"),
        EventMarkerType: {
          TypeId: markerTypeId,
          TypeName: markerTypeName,
          TypeLabel: markerTypeLabel,
          TypeColor: markerColor,
        },
        SiteIds: siteIds,
        FilePaths: upload,
      };

      APIutil.postData(url.post_EventMarker, data)
        .then(() => {
          if (selectedEventMarker.eventMarkerId > 0) {
            setAmplitudeEvent("Event Marker", {
              "Create/Edit": "Edit",
              "Marker Type": data.EventMarkerType.TypeName,
              "Marker Color": data.EventMarkerType.TypeColor,
              "Buildings": data.SiteIds.length,
              "Attachments": data.FilePaths.length,
            });
          } else {
            setAmplitudeEvent("Event Marker", {
              "Create/Edit": "Create",
              "Marker Type": data.EventMarkerType.TypeName,
              "Marker Color": data.EventMarkerType.TypeColor,
              "Buildings": data.SiteIds.length,
              "Attachments": data.FilePaths.length,
            });
          }
          backToList(false);
        })
        .catch((error) => {
          throw error;
        });
    }
  }

  function retrieveFile(docs): Array<Attachment> {
    let file: Array<Attachment> = [];
    let fileFormated: Array<Attachment> = [];

    APIutil.postData(url.edit_files, docs)
      .then((response) => {
        file = response.data;

        let fPaths: Array<FileUpload> = [];
        file.forEach((f) => {
          fPaths.push({
            Key: f.id,
            Val: f.name,
          });

          fileFormated.push({
            id: f.id,
            name: f.name,
            size: formatBytes(f.size),
            lastModifiedDate: f.lastModifiedDate,
            type: f.type,
          });
        });
        setupload(fPaths);
        setAttachments(fileFormated);
      })
      .catch((error) => {
        throw error;
      });
    return file;
  }

  const setEditFields = () => {
    if (selectedEventMarker.eventMarkerId > 0) {
      setCheckForSave(true);
      setMarkerTypeUsage(selectedEventMarker.instancesOfType);
      setMarkerId(selectedEventMarker.eventMarkerId);
      setMarkerDescription(selectedEventMarker.eventMarkerDescription);
      setMarkerTypeId(selectedEventMarker.eventMarkerTypeId);
      setMarkerTypeName(selectedEventMarker.eventMarkerTypeTitle);
      setMarkerTypeLabel(selectedEventMarker.eventMarkerTypeAcronym);
      setMarkerColor(selectedEventMarker.eventMarkerTypeColor);
      let utcOffsetMinute = moment().utcOffset();
      var l_BuildingDate;
      if (utcOffsetMinute >= 0) {
        l_BuildingDate = moment(
          moment
            .parseZone(selectedEventMarker.eventMarkerDate)
            .format("YYYY-MM-DD")
        ).add(utcOffsetMinute, "minutes");
      } else {
        l_BuildingDate = moment(
          moment
            .parseZone(selectedEventMarker.eventMarkerDate)
            .format("YYYY-MM-DD")
        ).subtract(utcOffsetMinute, "minutes");
      }

      setDateValue(l_BuildingDate);

      if (selectedEventMarker.eventMarkerSiteIdString !== "") {
        let sIdStrings = selectedEventMarker.eventMarkerSiteIdString.split(";");
        let sIds: number[] = [];

        sIdStrings.forEach((sId) => {
          // eslint-disable-next-line use-isnan
          if (!Number.isNaN(sId)) sIds.push(parseInt(sId));
        });
        selectedEventMarker.eventMarkerSiteIds = sIds;
      }

      if (
        selectedEventMarker.eventMarkerDocuments &&
        selectedEventMarker.eventMarkerDocuments.length > 0
      ) {
        retrieveFile(selectedEventMarker.eventMarkerDocuments);
      }
    }
  };

  useEffect(() => {
    dispatch(getAllResources());
    dispatch(getAllBuildingsList());
    dispatch(getUserPreferences());
    setEditFields();
  }, []);

  useEffect(() => {
    if (preferencesData) {
      setUserFormat(
        Conversions.UserPreferenceDateFormat_DatePicker(preferencesData)
      );
    }
  }, [preferencesData]);

  useEffect(() => {
    if (buildingsSelector && buildingsSelector !== undefined || buildingsSelector !== null) {
      let value: Array<BuildingFormat> = [];
      let otherVal: Array<string> = [];
      let buildVal: Array<string> = [];
      let hasSelectedSites: boolean =
        selectedEventMarker &&
        selectedEventMarker.eventMarkerSiteIds &&
        selectedEventMarker.eventMarkerSiteIds.length > 0;

      // eslint-disable-next-line array-callback-return
      buildingsSelector.map((bl) => {
        if (
          hasSelectedSites &&
          selectedEventMarker.eventMarkerSiteIds.indexOf(bl.siteID) >= 0
        ) {
          otherVal.push(bl.siteName);
        }
        value.push({ value: bl.siteName, label: bl.siteName });
        buildVal.push(bl.siteName);
      });

      let sortedValue = buildVal.sort((a, b) => {
        let fa = a.toLowerCase(),
          fb = b.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });

      console.log(value);
      let sortedObject = value.sort((a, b) => {
        let fa = a.label.toLowerCase(),
          fb = b.label.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });

      let sortedOtherVal = otherVal.sort((a, b) => {
        let fa = a.toLowerCase(),
          fb = b.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });

      setBuildings(sortedObject);
      setBldList(otherVal.sort());
      setbuildingVals(sortedValue);
      setSelected(sortedOtherVal);
    }
  }, [buildingsSelector]);

  const sortValues = (buildVal) => {
    let sortedValue = buildVal.sort((a, b) => {
      let fa = a.toLowerCase(),
        fb = b.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    return sortedValue;
  };

  function setTypeIdValue(typeId: number) {
    if (typeId >= 0 && typeId !== markerTypeId) setMarkerTypeId(typeId);
  }

  function setTypeNameValue(typeName: string) {
    if (typeName !== markerTypeName) setMarkerTypeName(typeName);
  }

  function setTypeLabelValue(labelText: string) {
    if (labelText !== markerTypeLabel) setMarkerTypeLabel(labelText);
  }

  function setTypeColorValue(hexColor: string) {
    if (hexColor !== markerColor) {
      setMarkerColor(hexColor);
    }
  }

  function resetAndOpen() {
    removeErrorFile();
    open();
  }

  const handleBuildingList = (value) => {
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === buildingVals.length ? [] : buildingVals);
      return;
    }
    setSelected(value);
    setBldList(value);
    setisSelectedError(false);
  };

  const handleDeleteList = (label) => {
    let removedBldn: Array<string> = bldList.filter((value) => value !== label);
    let removeSelected: Array<string> = selected.filter(
      (value) => value !== label
    );
    setBldList(removedBldn);
    setSelected(removeSelected);
  };

  const title: string =
    markerId > 0 ? labels["EditEvent.Text"] : labels["EventMarkerAdd.Text"];

  const setDisplay = (showEditEventMarker: boolean) => {
    setTypeErrors([false, true, true, false]);
    setShowTypeEdit(showEditEventMarker);
  };

  let okDescription: boolean = !checkForSave
    ? true
    : markerDescription !== "" &&
      markerDescription !== null &&
      markerDescription.length <= 100;
  let okEventLabel: boolean =
    markerTypeLabel !== "" &&
    markerTypeLabel !== null &&
    markerTypeLabel.length > 0 &&
    markerTypeLabel.length <= 3;
  let okEventName: boolean =
    markerTypeName !== "" &&
    markerTypeName !== null &&
    markerTypeName.length > 0 &&
    !duplicate &&
    markerTypeName.length <= 25;

  let okEventType: boolean =
    markerTypeId > 0 || (markerTypeId === 0 && okEventLabel && okEventName);

  function resetTypeErrors() {
    let arrErrors: Array<boolean> = [];
    arrErrors.push(markerTypeId === -1);
    arrErrors.push(!okEventName);
    arrErrors.push(!okEventType);
    setTypeErrors(arrErrors);
  }

  // checking to see if the user has a valid input selection.
  const validInputs = () => {
    resetTypeErrors();
    let checkDescription = false;
    let checkEventType = false;

    if (okDescription) {
      checkDescription = markerDescription === "" ? false : true;
    }

    if (okEventType) {
      checkEventType = markerTypeId === -1 ? false : true;
    }

    return checkDescription && checkEventType;
  };

  const setDescription = (value: string) => {
    setCheckForSave(true);
    setMarkerDescription(value);
  };

  useEffect(() => {
    setdisplayedOptions(buildingVals);
  }, [buildingVals]);

  useEffect(() => {
    const searchedOptions = buildingVals.filter((option) =>
      containsText(option, searchText)
    );
    setdisplayedOptions(searchedOptions);
  }, [searchText]);

  const CustomInput = forwardRef((params: any, ref) => (
    <TextField
      {...params}
      ref={ref}
      className="inputWhite"
      error={dateError}
      sx={{
        backgroundColor: "white",
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <EventIcon />
          </InputAdornment>
        ),
      }}
    />
  ));

  const CHIPS_LIMIT = 5;
  let chipsCount = 0;

  return (
    <div style={{ paddingTop: "16px" }}>
      {showTypeEdit ? (
        <Grid id="tableGrid" container spacing={2}>
          <Grid item xs={5}>
            <EventMarkerType
              typeId={markerTypeId}
              typeName={markerTypeName}
              typeLabel={markerTypeLabel}
              typeColor={markerColor}
              setTypeIdValue={setTypeIdValue}
              setTypeLabelValue={setTypeLabelValue}
              setTypeNameValue={setTypeNameValue}
              setTypeColorValue={setTypeColorValue}
              isEdit={true}
              setShowEdit={setDisplay}
              instancesOfType={markerTypeUsage}
              setErrors={typeErrors}
              duplicateValue={setDuplicate}
              eventMarkerData={eventMarkerData}
            />
          </Grid>
        </Grid>
      ) : (
        <div style={{ width: "1116px", paddingLeft: "16px" }}>
          <Grid id="tableGrid" container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">{title}</Typography>
              <div>
                <Link
                  id="linkEventMarkerBackToList"
                  onClick={() => {
                    backToList(false);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {labels["BackToList.Text"]}
                </Link>
              </div>
            </Grid>
            <Grid item xs={5}>
              <EventMarkerType
                typeId={markerTypeId}
                typeName={markerTypeName}
                typeLabel={markerTypeLabel}
                typeColor={markerColor}
                setTypeIdValue={setTypeIdValue}
                setTypeLabelValue={setTypeLabelValue}
                setTypeNameValue={setTypeNameValue}
                setTypeColorValue={setTypeColorValue}
                isEdit={false}
                setShowEdit={setDisplay}
                instancesOfType={markerTypeUsage}
                setErrors={typeErrors}
                duplicateValue={setDuplicate}
                eventMarkerData={eventMarkerData}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginLeft: "0" }}>
            <Grid item xs={5}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{
                    paddingTop: "24px !important",
                  }}
                >
                  <div className="evSubHeader">{labels["Details.Text"]}</div>
                  <div id="eDate" className="labelStandard">
                    {labels["EventDate.Text"]}
                  </div>

                  <DatePicker
                    id="datePickerEventMarker"
                    dateFormat={userFormat || "MM/dd/yyyy"}
                    data-test-id="eventMarkerDatePicker"
                    selected={new Date(dateValue)}
                    onChange={(newValue) => {
                      setDateValue(newValue);
                    }}
                    customInput={<CustomInput />}
                  />
                </Grid>
                {dateError && (
                  <>
                    <CancelIcon
                      color="error"
                      className="errorIcon"
                      fontSize="medium"
                    />
                    <div
                      className="labelError"
                      style={{ display: "inline-block" }}
                    >
                      {isRequiredText.replace("{0}", labels["EventDate.Text"])}
                    </div>
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  sx={{
                    paddingTop: "24px !important",
                  }}
                >
                  <p style={{ paddingTop: "14px" }} />
                  <div id="eBuildings" className="labelStandard">
                    {labels["BuildingsImpacted.Text"]}
                  </div>

                  <Select
                    id="selectEventMarkerBuildingSelector"
                    label=""
                    sx={{
                      backgroundColor: "white",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    fullWidth
                    onClose={() => {
                      setdisplayedOptions(buildingVals);
                    }}
                    onChange={(e) => handleBuildingList(e.target.value)}
                    error={isSelectedError}
                    value={selected}
                    multiple
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                    }}
                    renderValue={(selected: Array<any>) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {sortValues(selected)
                          .slice(0, CHIPS_LIMIT)
                          .map((value) => {
                            const label = value;
                            chipsCount = selected.length;

                            return (
                              <Chip
                                key={value}
                                color="primary"
                                label={label}
                                onDelete={() => {
                                  handleDeleteList(label);
                                }}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                }}
                              />
                            );
                          })}
                        {chipsCount > CHIPS_LIMIT && (
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "normal",
                              fontSize: "14px",
                              paddingLeft: "15px",
                              paddingTop: "10px",
                              color: "rgb(112, 112, 112)",
                            }}
                          >
                            + {selected.slice(CHIPS_LIMIT).length} items
                            selected
                          </Typography>
                        )}
                      </Box>
                    )}
                  >
                    <ListSubheader>
                      <TextField
                        id="buildingSelectorSearchfield"
                        size="small"
                        // Autofocus on textfield
                        sx={{
                          backgroundColor: "white",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        autoFocus
                        placeholder="Search..."
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    <MenuItem
                      value="all"
                      classes={{
                        root: isAllSelected ? classes.selectedAll : "",
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Box display="flex" justifyContent="flex-start">
                            <ListItemIcon>
                              <Checkbox
                                classes={{
                                  indeterminate: classes.indeterminateColor,
                                }}
                                checked={isAllSelected}
                                indeterminate={
                                  selected.length > 0 &&
                                  selected.length < buildingVals.length
                                }
                              />
                            </ListItemIcon>
                            <ListItemText
                              classes={{ primary: classes.selectAllText }}
                              primary="Select All"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box display="flex" justifyContent="flex-end" pl={1}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "normal",
                                fontSize: "14px",
                                paddingTop: "15px",
                                color: "rgb(112, 112, 112)",
                              }}
                            >
                              {selected.length} Selected
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </MenuItem>
                    <Divider />
                    {displayedOptions.map((value, index) => (
                      <MenuItem
                        id={`buildingSelector${value}`}
                        key={index}
                        value={value}
                      >
                        <Checkbox checked={selected.indexOf(value) > -1} />
                        <ListItemText primary={value} />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {isSelectedError && (
                  <>
                    <CancelIcon
                      color="error"
                      className="errorIcon"
                      fontSize="medium"
                    />
                    <div
                      className="labelError"
                      style={{ display: "inline-block" }}
                    >
                      {isRequiredText.replace(
                        "{0}",
                        labels["BuildingsImpacted.Text"]
                      )}
                    </div>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{ paddingTop: "24px", marginLeft: "0" }}
          >
            <Grid item xs={5}>
              <div className="labelStandard" style={{ marginBottom: "0px" }}>
                {labels["Description.Text"]}
              </div>
              <TextField
              id="textFieldEventMarkerDescription"
                onChange={(event) => {
                  setDescription(event.target.value);
                }}
                error={!okDescription}
                sx={{ backgroundColor: "#FFF", width: "450px" }}
                defaultValue={markerDescription}
                variant="outlined"
                inputProps={{ maxLength: 100 }}
                multiline
                rows={2}
                size="medium"
              />

              <div
                style={{ display: !okDescription ? "inline-block" : "none" }}
              >
                <CancelIcon className="errorIcon" color="error" />
                <span className="labelError">
                  {isRequiredText.replace("{0}", labels["Description.Text"])}
                </span>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{ paddingTop: "24px", marginLeft: "0" }}
          >
            <Grid item xs={5}>
              <div
                id="eDescription"
                className="labelStandard"
                style={{
                  color: fileError.includes(true) ? "#991909" : "#555555",
                }}
              >
                {labels["Attachments.Text"]}
              </div>
              <Box
                sx={{
                  cursor: "pointer",
                  position: "relative",
                  border: "2px dashed",
                  borderColor: fileError.includes(true) ? "#991909" : "#999999",
                  textAlign: "center",
                  height: "150px",
                  width: "100%",
                  margin: "0 0 16px 0",
                  backgroundColor: fileError.includes(true)
                    ? "#FBEBEA"
                    : "#fff",
                }}
              >
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  <DropFileText>{labels["DropFileHere.Text"]}</DropFileText>
                  <Box pb={2}>
                    {fileError.includes(true) ? (
                      <Button
                        id="buttonEventMarkerChooseFile"
                        className="eventMarkerButton eventMarkerButtonLg eventMarkerCancelButton"
                        variant="outlined"
                        sx={{ width: "130px" }}
                        onClick={(e) => {
                          resetAndOpen();
                          e.preventDefault();
                        }}
                      >
                        {labels["ChooseFile.Text"]}
                      </Button>
                    ) : (
                      <Button
                      id="buttonEventMarkerChooseFile"
                      className="eventMarkerButton eventMarkerButtonLg eventMarkerCancelButton"
                        variant="outlined"
                        sx={{ width: "130px" }}
                        onClick={(e) => {
                          open();
                          e.preventDefault();
                        }}
                      >
                        {labels["ChooseFile.Text"]}
                      </Button>
                    )}
                  </Box>

                  <BrowseFileText>
                    {labels["EventMarkerFileRequirements.Text"]}
                  </BrowseFileText>
                </div>
              </Box>
              {fileError.includes(true) && (
                <>
                  <div>
                    <IconButton
                      onClick={() => {
                        removeErrorFile();
                      }}
                      color="error"
                    >
                      <CancelIcon className="errorIcon" color="error" />
                    </IconButton>
                    <span
                      className="labelFileBold"
                      style={{
                        color: "#991909",
                        fontSize: "14px",
                        fontFamily: "ArialMT",
                      }}
                    >
                      Attach file types:{" "}
                      {labels["EventMarkerFileRequirements.Text"]}
                    </span>
                  </div>
                </>
              )}
              {attachments !== null && attachments.length > 0 && (
                <DragandDropFileList
                  removeFile={(id: number) => {
                    removeFile(id);
                  }}
                  attachments={attachments}
                />
              )}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              paddingLeft: "10px !important",
              marginLeft: "0",
              paddingBottom: "24px",
              paddingTop: "24px",
            }}
          >
            <ActionButtons
              returnToList={() => {
                backToList(false);
              }}
              saveAttachments={saveAttachments}
              labels={labels}
              fileError={fileError.includes(true)}
            />
          </Grid>
        </div>
      )}
    </div>
  );
};

export default CreateEventMarker;
